// extracted by mini-css-extract-plugin
module.exports = {"component":"Navigation_component__3RJhP","list":"Navigation_list__3Has2","item":"Navigation_item__1Z18G"};